import { jsx as _jsx } from "react/jsx-runtime";
import { useRpcRouter, useSettings } from '@nest/common-core-frontend-react';
import { AsyncSelect, cn } from '@nest/uikit-react';
import { apiQueryContains } from '@nest/utils-shared';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
const PAGE_SIZE = 20;
export function PrinterAutocomplete({ value, onChange, onBlur, disabled, placeholder, className }) {
    const { apiUrl } = useSettings();
    const printersClient = useRpcRouter(apiUrl);
    const [searchValue, setSearchValue] = useState('');
    const [open, setOpen] = useState(false);
    const printersQuery = useInfiniteQuery({
        queryKey: ['printers', searchValue],
        queryFn: async ({ pageParam = 0 }) => {
            return printersClient.printers.getAll.execute({
                filter: {
                    label: apiQueryContains(searchValue)
                },
                offset: pageParam,
                limit: PAGE_SIZE
            });
        },
        enabled: open,
        getNextPageParam: (lastPage, pages) => (lastPage.length === PAGE_SIZE ? pages.length * PAGE_SIZE : undefined),
        initialPageParam: 0
    });
    const printers = useMemo(() => printersQuery.data?.pages.flatMap(p => p) ?? [], [printersQuery.data?.pages.flat()]);
    return (_jsx(AsyncSelect, { value: value ?? null, onChange: onChange, onBlur: onBlur, onOpenChange: setOpen, isLoading: printersQuery.isLoading, disabled: disabled, placeholder: placeholder, className: cn('w-full', className), options: printers, onSearchValueChange: setSearchValue, onEndReached: () => printersQuery.fetchNextPage(), getOptionId: opt => opt.id.toString(), renderOption: opt => _jsx("div", { children: opt.label }), renderValue: opt => _jsx("div", { children: opt.label }) }));
}
//# sourceMappingURL=PrinterAutocomplete.js.map